import endpoint from "@/api/endpoint";

export default {
    all() {
        return window.axios.get(endpoint + "/api/ai");
    },
    click(data) {
        return window.axios.post(endpoint + "/api/ai/" + data.id + "/click");
    },
}
